import {
	AZURE_SPEECH_FAMILY,
	SPEECH_MAX_SPEAKERS_MAX,
	SPEECH_MAX_SPEAKERS_MIN,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type SpeechShape = {
	readonly family: string | null;
	readonly hasAzureSpeechSettings: boolean;
};

/** Active only when the Azure Speech settings section is shown. */
function isSpeechMaxSpeakersValid<T extends SpeechShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || !formData.hasAzureSpeechSettings) {
		return true;
	}

	const speakers = value.trim() === '' ? Number.NaN : Number(value);

	return (
		Number.isInteger(speakers) &&
		speakers >= SPEECH_MAX_SPEAKERS_MIN &&
		speakers <= SPEECH_MAX_SPEAKERS_MAX
	);
}

export default isSpeechMaxSpeakersValid;
